import comp from "./ManageStandard";
export default comp;
